import { IBaseModule, IEnergyFactsSend, ISearchResult } from "@/store/common/Types";
import { Actions, Mutations, Endpoints } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";

@Module
export default class EnergyFactsSendModule extends VuexModule implements IBaseModule {
    errors = {};
    energyFactsSend = {} as ISearchResult<IEnergyFactsSend>;
    energyFactsSendDetails = {} as IEnergyFactsSend;

    /**
     * Get Energy Facts Send errors
     * @returns array
     */
    get getEnergyFactsSendErrors() {
      return this.errors;
    }  

    /**
     * Get energy facts send search result
     * @returns ISearchResult<IEnergyFactsSend>
     */
    get getEnergyFacts() : ISearchResult<IEnergyFactsSend>{
      return this.energyFactsSend;
    }  

    /**
     * Get energy facts send details
     * @returns IEnergyFactsSend
     */
    get getEnergyFactsSendDetails() : IEnergyFactsSend{
      return this.energyFactsSendDetails;
    }  

    @Mutation
    [Mutations.SET_ERROR](error) {
      this.errors = { ...error };
    }

    @Mutation
    [Mutations.SET_ENERGY_FACTS_SEND](items: ISearchResult<IEnergyFactsSend>) {
        this.energyFactsSend = items;
    } 

    @Mutation
    [Mutations.SET_ENERGY_FACTS_SEND_DETAILS](item: IEnergyFactsSend) {
        this.energyFactsSendDetails = item;
    } 

    @Action
    [Actions.SEARCH_ENERGY_FACTS_SEND]() {         
        ApiService.setHeader();
        return ApiService.get(Endpoints.EnergyFactsSend)
            .then(({ data }) => {
              this.context.commit(Mutations.SET_ENERGY_FACTS_SEND, data);
            })
            .catch(({ response }) => {
                if (!response) {
                    this.context.commit(Mutations.SET_ERROR, [
                    "There was an error searching for energy facts send.",
                    ]);
                    return;
                }
                if (response.data && response.data.errors) {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                }
            });
    }

    @Action
    [Actions.LOAD_ENERGY_FACT_SEND_DETAILS](energyFactsSendId: string) {
      ApiService.setHeader();
      return ApiService.get(Endpoints.EnergyFactsSend, energyFactsSendId)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ENERGY_FACTS_SEND_DETAILS, data);
        })
        .catch(({ response }) => {
          if (!response) {
            this.context.commit(Mutations.SET_ERROR, [
              "There was an error loading the energy facts send.",
            ]);
            return;
          }
          if (response.data && response.data.errors) {
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
          }
        });
    }

    @Action
    [Actions.REQUEUE_FAILED_RECIPIENTS_FOR_ENERGY_FACTS_SEND](energyFactsSendId: string) {
      ApiService.setHeader();     
      return ApiService.patch(Endpoints.EnergyFactsSend + "/" + energyFactsSendId + "/requeue", {})
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          if (!response) {
            this.context.commit(Mutations.SET_ERROR, [
              "Failed to requeue the energy facts send.",
            ]);
            return;
          }
          if (response.data && response.data.errors) {
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
          }
          else{
            this.context.commit(Mutations.SET_ERROR, [
              "Failed to requeue the energy facts send.",
            ]);
          }
        });
    }

}